export default (value) => (!value ? value : value.substring(1));
